<template>
  <div>
    <v-dialog v-model="photoDialog">
      <v-card>
        <v-img
          :src="photoDialogUrl || null"
        ></v-img>
      </v-card>
    </v-dialog>
    <v-container fluid class="text-right mt-4">
      <p class="text-left font-weight-bold text-darkGreen font-readex text-uppercase">Souhrn objednávky</p>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels
            accordion
            multiple
            v-if="Object.keys(cart.items).length"
          >
            <v-expansion-panel
              v-for="(date, dateStr, index) in cart.items"
              :key="index"
              value="1"
            >
              <v-expansion-panel-header color="darkGreen" style="color: white" >
                <tr>
                  <th class="pr-6">{{getLocalizedWeekDay(dateStr)}}</th>
                  <th class="pr-6">{{getLocalizedDate(dateStr)}}</th>
                  <td class="pr-6">{{getSelectedTimesStr(dateStr)}}</td>
                  <td class="pr-6">{{getDayPrice(dateStr)}} Kč</td>
                </tr>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  v-for="(time, i) in date"
                  :key="i">
                  <v-data-table
                    v-if="time.length"
                    :headers="headers"
                    :items="time"
                    :expanded="expanded"
                    item-key="id"
                    mobile-breakpoint="50"
                    show-expand
                    class=" order-table"
                    hide-default-header
                    hide-default-footer
                    disable-sort
                    dense
                  >
                    <template v-slot:top >
                      <v-toolbar flat dense>
                        <v-toolbar-title class="text-readex font-weight-bold text-darkGreen">{{timeTypes.length ? timeTypes[i].name : ''}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon
                          class="justify-end"
                          color="red"
                          @click="recapDeleteTime(dateStr, i)"
                          v-if="time[0].editable"
                        >mdi-delete-forever</v-icon>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.photo="{ item }">
                      <v-icon
                        v-if="item.imageUrl"
                        small
                        class="mr-2"
                        @click="showPhoto(item.imageUrl)"
                      >
                        mdi-camera
                      </v-icon>
                    </template>
                    <template v-slot:item.nameStr="{ item }">
                      <div class="text-darkGreen font-weight-bold text-uppercase">{{item.name}}</div>
                    </template>
                    <template v-slot:item.priceStr="{ item }">
                      <span class="text-darkGreen font-weight-bold">{{item.price + ' Kč'}}</span>
                    </template>
                    <template v-slot:item.quantity="{ item }" v-if="cart.order">
                      <div class="d-flex justify-end">
                        <v-icon slot="prepend" color="red" @click="minusQuantityRecap(item)">fa-circle-minus</v-icon>
                        <v-text-field
                          v-model="item.quantity"
                          class="order-quantity mx-2"
                          type="number" min="1"
                          v-if="item.editable"
                          rounded
                          hide-details
                          outlined
                          style="min-width: 60px !important;max-width: 60px !important; ;background-color: white"
                          dense>
                        </v-text-field>
                        <v-icon slot="append" color="green" @click="plusQuantityRecap(item)">fa-circle-plus</v-icon>
                      </div>
                    </template>
                    <template v-slot:item.quantity="{ /* item */ }" v-else>
                      Objednáno
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td
                        :colspan="headers.length"
                        v-if="item.type === 'App\\Menu'"
                      >
                        <div
                          v-for="(menuItem, index) in item.drinks.concat(item.foods)" :key="index"
                        >{{menuItem.name}}</div>
                      </td>
                      <td
                        :colspan="headers.length"
                        v-else
                      >{{item.name}}</td>
                    </template>
                  </v-data-table>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div v-else>
            Košík je prázdný
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-right">
          <v-dialog v-model="userPreviewDialog">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="float-left" >
                Přehled uživatelů
              </v-btn>
            </template>
            <v-card>
              <v-card-title>Přehled uživatelů</v-card-title>
              <v-card-text>
                <v-col>
                  Objednávka pro uživatele: {{cart.order ? 'Ano' : 'Ne'}}
                </v-col>
                <v-col>
                  <h3>Strávníci</h3>
                  <div v-for="(boarder, index) in cart.boarders" :key="index">
                    {{boarder.fullName}}
                  </div>
                </v-col>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-btn
            :disabled="!Object.keys(cart.items).length"
            @click="checkCart"
            v-if="step === 3"
            class="ml-6 btn btn-green-gradient"
            dark
          >
            Další krok
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'NewStep3',
  data () {
    return {
      userPreviewDialog: false,
      expanded: true,
      headers: [
        { text: '', value: 'photo', sortable: false },
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'nameStr',
          width: 300
        },
        { text: 'Cena', value: 'priceStr' },
        { text: '', value: 'quantity' },
        { text: '', value: 'data-table-expand' }
      ],
      photoDialogUrl: null,
      photoDialog: false
    }
  },
  methods: {
    checkCart () {
      if (Object.keys(this.cart.items).length) {
        this.goToStep(4)
        this.$emit('stepFilled')
      }
    },
    cancelOrder () {
      this.reset()
      this.$emit('order-canceled')
    },
    getLocalizedDate (dateStr) {
      const date = new Date(dateStr)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    getLocalizedWeekDay (dateStr) {
      const date = new Date(dateStr)
      const localeDayStr = date.toLocaleDateString('cs-cz', { weekday: 'long' })
      return localeDayStr[0].toUpperCase() + localeDayStr.slice(1)
    },
    getSelectedTimesStr (date) {
      let timeNames = []
      if (this.timeTypes.length) {
        timeNames = [0, 1, 2, 3, 4, 5]
          .map(time => this.timeTypes[time].name)
      }
      return timeNames
        .filter((time, index) => this.cart.items[date][index].length)
        .join(', ')
    },
    getDayPrice (date) {
      const itemsPrices = this.cart.items[date]
        .flat()
        .map(item => item.quantity * item.price)
      return itemsPrices.reduce((prev, next) => prev + +next, 0)
    },
    showPhoto (url) {
      this.photoDialog = true
      const base = axios.defaults.baseURL.split('/')
      this.photoDialogUrl = `${base.slice(0, 3).join('')}${url}`
    },
    recapDeleteTime (date, timeIndex) {
      this.deleteTimeIndex({ date, timeIndex })
      this.updateShoppingCartStorage()
      this.$emit('deletedDay')
    },
    continueShopping () {
      this.dateDialog = true
      this.addToCartDialog = false
      this.expanded = []
      this.goToStep(2)
    },
    plusQuantityRecap (item) {
      ++item.quantity
      this.updateShoppingCartStorage()
    },
    minusQuantityRecap (item) {
      if (item.quantity > 1) {
        --item.quantity
        this.updateShoppingCartStorage()
      }
    },
    goToBillingInformation () {
      Object.keys(this.cart.items).forEach(day => {
        this.cart.items[day] = this.cart.items[day].map(time => time.filter(food => food.quantity > 0))

        if (!this.cart.items[day].flat().length) {
          delete this.cart.items[day]
        }
      })
      this.goToStep(4)
      this.$forceUpdate()
    },
    ...mapMutations({
      reset: 'ordering/reset',
      updateShoppingCartStorage: 'ordering/updateShoppingCartStorage',
      deleteTimeIndex: 'ordering/orderingStep3DeleteTime',
      goToStep: 'ordering/goToOrderingStep'
    })
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      cart: 'ordering/shoppingCart',
      timeTypes: 'ordering/timeTypes',
      step: 'ordering/step'
    }),
    // vuex bindings
    'cart.items': {
      get () {
        return this.$store.shoppingCart.state.cart.items
      },
      set (items) {
        this.$store.shoppingCart.state.cart.items = items
      }
    }
  }
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
>>>input::-webkit-outer-spin-button,
>>>input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
>>>input[type=number] {
  -moz-appearance: textfield;
}
</style>
